/* eslint-disable no-tabs */
import styled from 'styled-components'

export const OutlineContainer = styled.div`
width: 100%;
border-radius: 4px;
padding: 1rem;
display: flex;
flex-direction: column;
box-shadow: var(--SombraBackground);
border: 1px solid var(--${props => props.theme});
`

export const ComentariosContainer = styled.div`
display: flex;
justify-content: start;
width: 100%;
margin-top: 1.25rem;
margin-bottom: 1rem;
font-size: .875rem;

div{
background: var(--c2);
padding: .5rem;
width: 100%;
}

div:not(:last-child){
    margin-bottom: .75rem;
}

section{
    max-width: 70rem;
    width: 100%;
}
`

export const BoxContainer = styled.div`
width: 100%;
border-radius: 4px;
padding: 1rem;
display: flex;
color: white;
flex-direction: column;
background: var(--${props => props.theme});
`

export const ContainerFiltro = styled.div`
display: flex;
align-items: center;
background-color: white;
border-radius: 8px;
width: 100%;
`

export const InfoBox = styled.div`
display: flex;
align-items: center;
justify-content: center;
background: var(--Azul);
color: white;
font-size: .875rem;
border-radius: 0.25rem;
height: 4.5rem;
width: 100%;
box-shadow: var(--SombraBtns);

div{
    width: min-content;
    margin-left: .75rem;
}
`
export const OutlineTable = styled.div`
  border: 2px solid var(--c2);
  padding: .75rem;
  border-radius: 4px;
  margin-top: .75rem;
	th {
		padding: .5rem 0 .5rem 0;
		font-size: 12px;
		font-weight: 700;
		color: #4A5568;
		text-align: start;
	    justify-content: start;
		padding-left: 1.25rem;
		:first-child{
			text-align: start;
		}
	}
	td {
		background-color: var(--AzulOpacoBg);
		border-bottom: 3px solid #fff;
		border-top: 3px solid #fff;
	}
`

export const StyledSpan = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	:first-child{
		text-align: start;
	    justify-content: start;
		padding-left: 1.25rem;
        text-wrap: auto;
	}
    padding: 1rem 0;
	gap: .5rem;
`

export const Titulo = styled.h2`
font-family: 'Poppins';
font-weight: 500;
font-size: 1.25rem;
`

export const TabelaAvaliacoes = styled.table`
    border-collapse: collapse;
    width: 100%;
    tr {
        :first-child {
            padding: 0;
        }
    }
    tbody > tr {
        background-color: #EDF2F7;
        :first-child {
            padding: 0;
        }
        :nth-child(even) {
            background: #fff;
        }
    }
    td {
        font-size: 13px;
        padding: .75rem;
        :first-child {
            text-align: start;
            padding: .75rem 1.5rem .75rem 1.5rem; 
        }
        svg {
            font-size: 22px;
        }
        text-align: center;
    }
    th {
        color: var(--Gray2);
        font-size: 12px;
        padding: 1rem 1.5rem 1rem 1.5rem; 
        :first-child {
            text-align: start;
            padding: .75rem 1.5rem .75rem 1.5rem; 
        }
        text-align: center;
    }
`
